import React from 'react'

import { Moment } from 'moment'

import Modal from 'common/components/feedback/Modal'
import Button from 'common/components/general/Button'

interface CancelRunoutProps {
  translate: (key: string) => string
  showCancelRunout: boolean
  setShowCancelRunout: (show: boolean) => void
  submitCancelRunout: () => void
  loading: boolean
}

const CancelRunout: React.FC<CancelRunoutProps> = ({
  translate,
  showCancelRunout,
  setShowCancelRunout,
  submitCancelRunout,
  loading,
}) => {
  return (
    <>
      <Modal
        onCancel={() => setShowCancelRunout(false)}
        visible={showCancelRunout}
        title={translate('csi-dashboard.program-details.cancel-runout.title')}
        footer={
          <div>
            <Button
              onClick={() => {
                setShowCancelRunout(false)
              }}
            >
              {translate('general.cancel')}
            </Button>
            <Button
              onClick={async () => {
                await submitCancelRunout()
              }}
              type="primary"
              loading={loading}
              className="ml-8"
            >
              {translate('general.submit')}
            </Button>
          </div>
        }
      >
        <div>
          <span className="color-gray-8">{translate('csi-dashboard.program-details.cancel-runout.paragraph')}</span>
        </div>
      </Modal>
    </>
  )
}

export default CancelRunout
